import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material"

import BackIcon from "../../../components/BackIcon"
import { useLocation } from "react-router-dom"
import MapaUbicacion from "../components/MapaUbicacion"
import EventoCard from "../components/EventoCard"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../utils/date/HHMMSSFormatHour"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const BuscarEjecucionLabores = () => {
  const location = useLocation()
  const eventoEjutado = location.state
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Ejecución de Labor</b>
        </div>

        <Box className={StyledRoot}>
          {eventoEjutado ? (
            <>
              {/* Mostrar evento con EventoCard (readonly) */}
              <EventoCard
                evento={{
                  extendedProps: {
                    empleadoNombre: eventoEjutado.empleadoNombre,
                    localidadNombre: eventoEjutado.localidadNombre,
                    horarioDesc: eventoEjutado.horarioDesc,
                    plandescri: eventoEjutado.plandescri,
                    ejecfecha: normalFormatDate(eventoEjutado.ejecfecha),
                    ejechora: normalFormatHour(eventoEjutado.ejechora),
                  },
                }}
                isMobile={isMobile}
                seleccionado={true}
                readonly={true}
              />

              {/* Mostrar foto tomada centrada y responsiva */}
              {eventoEjutado.ejecimagen && (
                <Box sx={{ mt: 3, mb: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Foto tomada:
                  </Typography>
                  <Box
                    sx={{
                      width: isMobile ? "90vw" : "300px",
                      maxWidth: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={`data:image/jpeg;base64,${eventoEjutado.ejecimagen}`}
                      alt="Foto tomada"
                      style={{ width: "100%", borderRadius: "8px", objectFit: "cover" }}
                    />
                  </Box>
                </Box>
              )}

              {/* Mostrar ubicación marcada */}
              {eventoEjutado.ubicacion && (
                <MapaUbicacion
                  latitud={eventoEjutado.ubicacion.latitud}
                  longitud={eventoEjutado.ubicacion.longitud}
                  precision={eventoEjutado.ubicacion.precision}
                  isMobile={isMobile}
                />
              )}
            </>
          ) : (
            <Typography variant="body2">No hay información del evento.</Typography>
          )}
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default BuscarEjecucionLabores
